import React, { useState } from 'react';
import { Building2, BarChart3, Users } from 'lucide-react';
import HOHCapTable from './HOHCapTable';
import HOASCapTable from './HOASCapTable';

const CapTable: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'hoh' | 'hoas'>('hoh');

  return (
    <div className="min-h-screen bg-slate-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-2xl font-bold text-slate-900">Cap Table</h1>
              <p className="text-slate-600 mt-2">Shareholder ownership and equity distribution</p>
            </div>
            <div className="flex items-center space-x-2 mt-4 sm:mt-0">
              <BarChart3 className="w-5 h-5 text-slate-500" />
              <span className="text-sm text-slate-600">Ownership Overview</span>
            </div>
          </div>
        </div>

        {/* Company Navigation Tabs */}
        <div className="bg-white rounded-xl shadow-md border border-slate-200 mb-8">
          <div className="border-b border-slate-200">
            <nav className="-mb-px flex">
              <button
                onClick={() => setActiveTab('hoh')}
                className={`flex-1 py-4 px-6 border-b-2 font-medium text-sm flex items-center justify-center space-x-3 transition-all duration-200 ${
                  activeTab === 'hoh'
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300 hover:bg-slate-50'
                }`}
              >
                <span className="text-xl">🇸🇬</span>
                <div className="flex flex-col items-start">
                  <span className="font-semibold">Hotel Online Holding Pte. Ltd.</span>
                  <span className="text-xs text-slate-500">Singapore Entity</span>
                </div>
                <Building2 className="w-4 h-4" />
              </button>
              <button
                onClick={() => setActiveTab('hoas')}
                className={`flex-1 py-4 px-6 border-b-2 font-medium text-sm flex items-center justify-center space-x-3 transition-all duration-200 ${
                  activeTab === 'hoas'
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300 hover:bg-slate-50'
                }`}
              >
                <span className="text-xl">🇳🇴</span>
                <div className="flex flex-col items-start">
                  <span className="font-semibold">HotelOnline AS</span>
                  <span className="text-xs text-slate-500">Norwegian Entity</span>
                </div>
                <Building2 className="w-4 h-4" />
              </button>
            </nav>
          </div>
        </div>

        {/* Content */}
        <div>
          {activeTab === 'hoh' ? <HOHCapTable /> : <HOASCapTable />}
        </div>
      </main>
    </div>
  );
};

export default CapTable; 